const page = require('../../../../../components/page/page')
const customerDt = require('./customer-dt')
const navmenu = require('../../../../../components/navmenu/navmenu')

import customerPage from "./customer-page.html";

/****************ELEMENTS*****************/
var HTMLwasSelected = false

//insert the page  on the body
function HTMLselect(detail) {
   HTMLwasSelected = true

   //load the page to the index
   const body = document.body
   body.insertAdjacentHTML("beforeend", customerPage)

   customerDt.start({ "dest": "customer", "elem": "dt", "act": "select", "entity": "customer" })
   navmenu.start({
      act: 'renderNavMenu',
      container: '#customerdt-navmenu-container',
      items: [
         {
            label: 'Acc. Receivable All',
            icon: 'report_receive',
            dest: 'customer',
            action: 'printReport',
            extraData: { entity: 'customer', elem: 'fullcont', reportName: 'account-receivable-all' }
         },
         {
            label: 'Profit Report All',
            icon: 'profit',
            dest: 'customer',
            action: 'printReport',
            extraData: { entity: 'customer', elem: 'fullcont', reportName: 'customer-profit-all' }
         },
         {
            label: 'All Contacts',
            icon: 'contact_page',
            dest: 'customer',
            action: 'printReport',
            extraData: { entity: 'customer', elem: 'fullcont', reportName: 'customer-contact-directory' }
         }
      ]
   })
}/*init*/

/****************ELEMENTS*****************/

export function start(detail) {

   if (!HTMLwasSelected) { HTMLselect(detail) }

   obj[detail.act].start(detail)
}

const obj = {

   show: { start: (detail) => { page.start(detail) } },

}/**/


